import { Button, Modal, Row } from "react-bootstrap";
import { Form, Formik } from 'formik';
import * as Yup from 'yup';
import { MyDatePicker } from "../../ui/controls/MyDatePicker";
import { useSelector, useDispatch } from 'react-redux';
import moment from 'moment'
import { MyTextInput66 } from "../../ui/controls/MyTextInput66";
import { onlyIntegers } from "../../../helpers/numericFields";
import { getBlankSpacesInCalendar } from "../../../store/slices/catalogue/thunks";

export const SearchForm = ({ isOpen, setIsOpen }) => {
  const dispatch = useDispatch();

  return (
    <>
      <Modal
        size="xl"
        show={isOpen}
        aria-labelledby="example-modal-sizes-title-lg"
      >
        <Modal.Header>
          <Modal.Title >
            Buscar Espacio Disponible
          </Modal.Title>
          <Button
            onClick={() => setIsOpen(false)}
            className="btn-close"
            variant=""
          >
            x
          </Button>
        </Modal.Header>

        <Formik
          initialValues={{
            startEndDate: '',
            days: "",
          }}
          onSubmit={(({ startEndDate, days }, { resetForm, setErrors }) => {

            if (!startEndDate || startEndDate.length !== 2) {
              return setErrors({ "startEndDate": "Requerido" })
            }

            let startDate = startEndDate[0].year + "-" + (startEndDate[0].monthIndex + 1) + "-" + startEndDate[0].day
            let endDate = startEndDate[1].year + "-" + (startEndDate[1].monthIndex + 1) + "-" + startEndDate[1].day

            const success = () => {
              setIsOpen(false)
            }

            dispatch(getBlankSpacesInCalendar(startDate, endDate, days, success));
          })}
          validationSchema={
            Yup.object({
            })
          }
        >

          {
            ({ setFieldValue }) => (
              <Form>
                <Modal.Body>
                  <Row>
                    <div className="col-8">
                      <div className=" row mb-4">
                        <MyDatePicker
                          label='Rango de fechas:*' name="startEndDate" mode='horizontal'
                          className="form-control fc-datepicker"
                          singleSelect="true"
                          placeholder="dd/mm/aaaa ~ dd/mm/aaaa"
                          range
                          onChange={e => {
                            setFieldValue("startEndDate", e);
                          }} />
                      </div>
                    </div>
                    <div className="col-lg-4 col-md-12">
                      <div className=" row mb-4">
                        <MyTextInput66 label='Dias:' name='days' mode='horizontal'
                          onChange={(e) => {
                            if (!onlyIntegers(e)) {
                              return
                            }
                            setFieldValue("days", e.target.value);
                          }} />
                      </div>
                    </div>
                  </Row>
                  <div style={{ fontSize: 13 }}>* Dato obligatorio</div>
                </Modal.Body>

                <Modal.Footer>
                  <div style={{ width: "100%" }}>
                    <Button variant="primary" type="submit" style={{ float: "right" }}>
                      Buscar
                    </Button>
                  </div>
                </Modal.Footer>
              </Form>
            )
          }
        </Formik>


      </Modal>
    </>
  )
}
